import React, { useState } from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import SiteDown from 'sitedown';
import { Route, Switch } from 'react-router-dom';
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from './configs/AppConfig';
import IdleComponent from "./components/reusable-components/idleTimerComponent";
import VersionCheck from "./components/reusable-components/appVersionComponent";
import JiraReportComponent from "./components/ReportIssue/JiraReportComponent";
import { QueryClient, QueryClientProvider } from 'react-query';
import { env } from 'configs/EnvironmentConfig';


const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};
const data = window.navigator.userAgent.toLowerCase();
const queryClient = new QueryClient();
const isCheck = false;

function App() {
  const [isSiteDown, setIsSiteDown] = useState(env.SITE_DOWN);
  //  console.log("process.env.NODE_ENV",env)
//  if(env==="production"){
//   console.log= function(){}
//  }
  return (
    <div className="App">
      {isSiteDown ? (
        <SiteDown />
      ) : (
        <>
      <Provider store={store}>
      <QueryClientProvider client={queryClient}>
      {/* <IdleComponent></IdleComponent> */}
        <VersionCheck></VersionCheck>
        <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
        {isCheck?
          <Router>
            {/* <JiraReportComponent projectKey="ERP" jiraApiUrl=""> */}
            <Switch>
              <Route path="/" component={Views}/>
            </Switch>
            {/* </JiraReportComponent> */}
          </Router>:
          <Router>
            <JiraReportComponent projectKey="ERP" jiraApiUrl="">
            <Switch>
              <Route path="/" component={Views}/>
            </Switch>
            </JiraReportComponent>
          </Router>
          }
        </ThemeSwitcherProvider>
      </QueryClientProvider>
      </Provider>
      </>
      )}
    </div>
  );
}

export default App;
